import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 10px;

  width: 100%;
  font-family: ${({ theme }) => theme.font.fontFamily};
  padding-bottom: 20px;

  grid-area: ${({ gridArea }) => gridArea};
`;

export const Checkboxes = styled.div`
  display: grid;
  grid-template-columns: ${({ columns }) => (columns ? `1fr 1fr` : "1fr")};
  gap: 20px;

  width: 100%;
`;
